import { useState } from 'react';
import { differenceInDays } from 'date-fns';
import type { Granularity } from '@/types/analyticsV2';

const defaultGranularity = (fromDate: string, toDate: string): Granularity => {
  if (!fromDate || !toDate) return 'day';
  return differenceInDays(new Date(toDate), new Date(fromDate)) <= 31 ? 'day' : 'week';
};

// Follows the range; a picked bucket size holds until the range changes.
export function useChartGranularity(fromDate: string, toDate: string) {
  const range = `${fromDate}:${toDate}`;
  const [picked, setPicked] = useState<{ range: string; granularity: Granularity } | null>(null);
  const granularity = picked?.range === range ? picked.granularity : defaultGranularity(fromDate, toDate);
  const pick = (next: Granularity) => setPicked({ range, granularity: next });
  return [granularity, pick] as const;
}
